import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { SettingsService } from './settings.service';
import { AddNewLevelComponent } from './add-new-level/add-new-level.component';
import { ConfirmationDialogComponent } from 'src/app/shared/modals/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateOrganisationHierarchyService } from '../create-organisation-hierarchy/create-organisation-hierarchy.service';
import { TabsService } from '../../tabs.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  settingLevelNamesData: any = [];
  displayedCountryColumns: string[] = ['id', 'countries', 'edit','delete'];
  displayedRoleColumns: string[] = ['position', 'role', 'edit', 'delete'];
  displayedGroupColumns: string[] = ['position', 'name', 'active', 'edit', 'delete'];
  displayedRegionColumns: string[] = ['position', 'region', 'edit', 'delete'];
  displayedProgramColumns: string[] = ['position', 'program', 'edit', 'delete'];
  settingLevelNamesDataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  isLoading = true;
  blockLoader: string = 'blockLoader';
  totalHierarchies: number = 0;
  currentHierarchies: number = 0;
  hierarchies: any = [];
  levelId:any;
  initialHierarchySelected: boolean = false;
  templateName: string = '';
  @Input() organisationId: string = '';
  valuesData: any;
  orgDataSub: any;
  organizationHierarchy: any;

  constructor(public dialog: MatDialog,
	private snackbar: MatSnackBar,
    private settingsService: SettingsService,
    private spinner: NgxSpinnerService,
	private createOrganisationHierarchyService: CreateOrganisationHierarchyService,
	private tabsService:TabsService
  ) {
	this.tabsService.organisationId$.subscribe(async organisationId => {
		this.organisationId = organisationId;
		// console.log('organisationId--',this.organisationId);
	});
   }

	async ngOnInit() {
		this.getSettingsLevelsName();
	}

	ngAfterViewInit() {
		this.settingLevelNamesDataSource.paginator = this.paginator;
	}

	getSettingsLevelsName() {
		// console.log(this.organisationId);
		const orgDataObs = this.settingsService.getOrganisationHierarchyObs(this.organisationId);

		if (orgDataObs) {
			this.orgDataSub = orgDataObs.subscribe((orgData: any) => {
				this.valuesData = orgData.hierarchies;
				this.organizationHierarchy = orgData.hierarchy;
				// console.log('this.organisationHierarchy', this.valuesData);
				this.settingLevelNamesData = [];

				for (let hierarchy of this.valuesData) {
					this.settingLevelNamesData.push(hierarchy);
				}
				// console.log('this.settingLevelNamesData', this.settingLevelNamesData);
				this.settingLevelNamesDataSource = new MatTableDataSource<any>(this.valuesData);
				this.settingLevelNamesDataSource.paginator = this.paginator;
			});
		}
	}

    // async deleteSetting(element:any){
    //   console.log("deleteSubject", element.id);
    //       this.spinner.show();
    //       await this.settingsService.deleteSetting(element.id).then((el) => {
    //         console.log('el',el)
    //         if(el){
    //           this.spinner.hide();
    //           this.dialog.open(SuccessComponent,{data:{title:"Deleted!",subTitle:"Store deleted successfully."}});
    //         }else{
    //           this.spinner.hide();
    //           alert("Something went wrong");
    //         }

    //       });
    //     }

	addNewLevel(data:any=null, index:any=null) {
		if (data) {
			data = `${data.charAt(0).toUpperCase()}${data.slice(1)}`
		}

		const newLevelDialog = this.dialog.open(AddNewLevelComponent, {
			maxWidth: '80%',
			minWidth: 'fit-content',
			data: {
				currentHierarchies: this.settingLevelNamesData,
				organisationId:this.organisationId,
				id: this.levelId,
				editData: data,
				index: index
			}
		});

		newLevelDialog.afterClosed().subscribe(result => {
			if (result && result === 'success') {
				this.snackbar.open("Hierarchy changed successfully!", "OK", {
					duration: 3000
				});
			}
		});
	}

	// onClickValueEdit(element:any, index:number){
	// 	console.log()
	// }

	async deleteLevel(data:any, levelIndex: number) {
		// console.log('data',data,levelIndex)
		const confirmationDialog = this.dialog.open(ConfirmationDialogComponent, {
			maxWidth: '40%',
			// minWidth: 'fit-content',
			data: {
				question: 'Are you sure you want to delete this level?',
				cancelButtonText: 'No',
				confirmationButtonText: 'Yes'
			}
		});

		confirmationDialog.afterClosed().subscribe(async result => {
			if (result && result === 'confirm') {
				await this.spinner.show("blockLoader");
				await this.settingsService.deleteLevel(levelIndex, this.settingLevelNamesData, this.organisationId, this.organizationHierarchy);
				await this.spinner.hide("blockLoader");
				this.snackbar.open("Level deleted successfully!", "OK", {
					duration: 3000
				});
			}
		});
	}

	isCreateTemplateDisabled() {
		if (!this.initialHierarchySelected || !this.templateName || this.currentHierarchies === 0) {
			return true;
		}

		for (let i = 0; i < this.currentHierarchies; i += 1) {
			let hierarchyValues = this.hierarchies[i].values;

			if (!this.hierarchies[i].name || hierarchyValues.length <= 0) {
				return true;
			}

			for (let j = 0; j < hierarchyValues.length; j += 1) {
				hierarchyValues[j] = hierarchyValues[j].trim();

				if (!hierarchyValues[j]) {
					return true;
				}
			}
		}

		return false;
	}

	async initialHierarchySelection(selectedVal: any) {
		this.initialHierarchySelected = true;
		this.hierarchies[0].name = selectedVal;
		this.hierarchies[0].values.push("");
		this.currentHierarchies += 1;
	}

	shouldHierarchyBeDisabled(hierarchyName: string) {
		for (let tempHierarchy of this.hierarchies) {
			if (tempHierarchy.name === hierarchyName) {
				return true;
			}
		}

		return false;
	}

	addHierarchyValue(index: number) {
		this.hierarchies[index].values.push("");
	}

	addHierarchy() {
		this.hierarchies[this.currentHierarchies] = {
			name: "",
			values: [""]
		}

		this.currentHierarchies += 1;
	}

	isAddHierarchyDisabled() {
		return this.currentHierarchies === this.totalHierarchies;
	}

	removeHierarchy(index: number) {
		this.hierarchies.splice(index, 1);
		this.currentHierarchies -= 1;
	}

	removeHierarchyValue(i: number, j: number) {
		this.hierarchies[i].values.splice(j, 1);
	}

	hierarchyValueTracker(index: number, item: any) {
		return index;
	}

	ngOnDestroy() {
		if (this.orgDataSub) {
			this.orgDataSub.unsubscribe();
		}
	}
}
